import { getGuidebookStepById } from 'components/content/guidebook/content'
import { GuidebookCreateAccount } from 'components/content/guidebook/guidebookCreateAccount/GuidebookCreateAccount'
import { GuidebookFeatureList } from 'components/content/guidebook/guidebookFeatureList/GuidebookFeatureList'
import { GuidebookStepAffairsInOrder } from 'components/content/guidebook/guidebookStepAffairsInOrder/GuidebookStepAffairsInOrder'
import { GuidebookStepCloseAccounts } from 'components/content/guidebook/guidebookStepCloseAccounts/GuidebookStepCloseAccounts'
import { GuidebookStepDigitalLegacy } from 'components/content/guidebook/guidebookStepDigitalLegacy/GuidebookStepDigitalLegacy'
import { GuidebookStepLovedOne } from 'components/content/guidebook/guidebookStepLovedOne/GuidebookStepLovedOne'
import { GuidebookStepMemorialize } from 'components/content/guidebook/guidebookStepMemorialize/GuidebookStepMemorialize'
import { Spacer } from 'components/spacer/Spacer'

export function GuidebookLP(props: { hideSignup?: boolean }) {
  return (
    <>
      <GuidebookStepAffairsInOrder step={getGuidebookStepById('affairs')} />
      <Spacer size={[3, 4]} />

      <GuidebookStepDigitalLegacy step={getGuidebookStepById('legacy')} />
      <Spacer size={[4.5, 6]} />

      <GuidebookFeatureList />
      <Spacer size={[4.5, 6]} />

      <GuidebookStepMemorialize step={getGuidebookStepById('accounts')} />
      <Spacer size={[4.5, 6]} />

      <GuidebookStepCloseAccounts step={getGuidebookStepById('cancel')} />
      <Spacer size={[4.5, 6]} />

      <GuidebookStepLovedOne step={getGuidebookStepById('plan')} />
      <Spacer size={[4.5, 6]} />

      {!props.hideSignup && (
        <div className="desktop-only">
          <GuidebookCreateAccount />
          <Spacer size={[4.5, 6]} />
        </div>
      )}
    </>
  )
}
